import React, { PureComponent } from 'react';
import { RightChevron } from 'appSrc/components/UI';
import style from './styles/style.module.css';

const defaultArrowProps = {
    size: 14,
};

export default class ExternalLink extends PureComponent {
    render() {
        const arrowProps = {
            ...defaultArrowProps,
            ...this.props.arrowProps,
            className: `${ style.linkArrow } ${ this.props.arrowProps.className || '' }`,
        };
        return (
            <a className={ `${ style.externalLink } ${ this.props.className }` }
            href={ this.props.to }
            target={ this.props.target }
            rel='noopener noreferrer'
            style={ this.props.style }
            title={ this.props.title }
            alt={ this.props.alt }
            onClick={ this.props.onClick }>
                { this.props.children }
                { this.props.arrow &&
                    <RightChevron { ...arrowProps } />
                }
            </a>
        );
    }
}
ExternalLink.defaultProps = {
    to: '#',
    children: null,
    className: '',
    target: '_blank',
    arrowProps: {},
    title: '',
};
